(function () {
  'use strict';

  angular.module('app').service('ProviderTypeModalService', ProviderTypeModalService);

  ProviderTypeModalService.$inject = ['ModalService'];

  function ProviderTypeModalService(ModalService) {
    var service = {
      openProviderTypes: openProviderTypes,
    };

    return service;

    ////////////////

    function openProviderTypes(getItemsCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/provider-types/modals/provider-type-list-modal.html',
        controller: ProviderTypeListModalCtrl,
        controllerAs: 'vm',
      }).then(function (modal) {
        modal.element.modal();

        modal.element.on('hidden.bs.modal', function () {
          getItemsCallback();
        });
      });
    }

    function ProviderTypeListModalCtrl(
      ProviderTypeService,
      LanguageService,
      AbilityService,
      UtilService
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.permissions = {
        canList: AbilityService.can('index_providertype_accountadmin'),
        canCreate: AbilityService.can('create_providertype_accountadmin'),
      };

      // Methods
      vm.addItem = addItem;
      vm.onSavedItem = onSavedItem;
      vm.cancel = cancel;
      vm.onCanceledItem = onCanceledItem;
      vm.onShowItem = onShowItem;
      // vm.onDeletedItem  = onDeletedItem;

      // Initializers
      // getItems();
      getAdditionalLanguages();

      // TODO: @willy - how are we going to deal with translations
      // 1- No translation / Per user language / Per content language

      function getAdditionalLanguages() {
        LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
          let languages = data.items;

          vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
          vm.additionalLanguages = languages.filter((language) => !language.is_default);

          getItems('');
        });
      }

      function getItems(selectedItem) {
        vm.filterCriteria = ProviderTypeService.getFilterCriteria();
        vm.filterCriteria.lang = vm.defaultLanguage;

        vm.loadingItems = true;
        ProviderTypeService.getProviderTypes(vm.filterCriteria).then(function (data) {
          vm.items = data.items;
          vm.meta = data.meta;

          if (selectedItem) {
            vm.UtilService.itemListChanged(selectedItem.id);
          }

          vm.loadingItems = false;
        });

        vm.modalTitle = 'PROVIDER_TYPES';
      }

      function getItem(item) {
        vm.item = null;

        vm.loadingItem = true;
        ProviderTypeService.getProviderType(item.id, vm.defaultLanguage).then(function (data) {
          vm.item = data;

          vm.loadingItem = false;
        });
      }

      function addItem() {
        vm.createMode = true;
        vm.item = {};
        vm.modalTitle = 'NEW_PROVIDER_TYPE';
      }

      function onSavedItem(item) {
        //vm.UtilService._clearFlashMessage();
        //getItem(item);
        cancel(item);
      }

      function cancel(item) {
        vm.createMode = false;
        vm.editMode = false;

        getItems(item);
      }

      function onCanceledItem() {
        cancel('');
      }

      function onShowItem(item, mode) {
        vm.editMode = true;
        vm.modalTitle = 'PROVIDER_TYPE_DETAILS';

        vm.mode = mode;

        getItem(item);
      }

      // function onDeletedItem() {
      //     cancel();
      // }
    }
  }
})();
